import { PaymentOption } from '@/components/Payment/PaymentMethods/types';
import * as S from '@/components/Payment/PaymentMethods.styles';
import { PaymentMethod } from '@/api/types/payments.types';

type Props = {
  option: PaymentOption;
  isSelected: boolean;
  onSelect: (paymentMethod: PaymentMethod) => void;
};

export function PaymentMethodOption({ option, isSelected, onSelect }: Props) {
  return (
    <S.ListItem
      dataTestId={option.value}
      onChangeHook={() => onSelect(option.value)}
      value={isSelected}
      label={option.label}
      $order={option.order}
      labelIcon={option.labelIcon}
      labelPosition="right"
      appearance="radio"
      size="sm"
      color="secondary"
      hasBorderBottom={false}
    />
  );
}
